import React from 'react';
import { Wrap, WrapItem, Heading, Box } from '@chakra-ui/react';

const TrackerAppSchema = () => {
  return (
    <Wrap spacing="20px" justify="space-around" mt={8} mb={8}>
      <WrapItem>
        <Box width="auto">
          <Heading as="p" size="sm" mb={2}>
            User
          </Heading>
          <Box
            overflow="hidden"
            borderRadius="2xl"
            borderWidth="4px"
            borderColor="transparent"
            transition=".1s linear"
            _hover={{
              borderColor: 'orange.500',
              backgroundColor: 'rgba(0,0,0,0.1)',
            }}
          >
            <pre
              style={{
                padding: 10,
                fontSize: 'medium',
              }}
            >
              {
                'userSchema: {\n\temail: {\n\t\ttype: String,\n\t\tunique: true,\n\t\trequired: true\n\t},\n\tpassword: {\n\t\ttype: String,\n\t\trequired: true\n\t}\n}'
              }
            </pre>
          </Box>
        </Box>
      </WrapItem>
      <WrapItem>
        <Box width="auto">
          <Heading as="p" size="sm" mb={2}>
            Track
          </Heading>
          <Box
            overflow="hidden"
            borderRadius="2xl"
            borderWidth="4px"
            borderColor="transparent"
            transition=".1s linear"
            _hover={{
              borderColor: 'orange.500',
              backgroundColor: 'rgba(0,0,0,0.1)',
            }}
          >
            <pre
              style={{
                padding: 10,
                fontSize: 'medium',
              }}
            >
              {
                'trackSchema: {\n\tuserID: {\n\t\ttype: ObjectID,\n\t\tref: "user"\n\t},\n\tname: {\n\t\ttype: String,\n\t\tdefault: ""\n\t},\n\tlocations: [pointSchema]\n}'
              }
            </pre>
          </Box>
        </Box>
      </WrapItem>
      <WrapItem>
        <Box width="auto">
          <Heading as="p" size="sm" mb={2}>
            Points
          </Heading>
          <Box
            overflow="hidden"
            borderRadius="2xl"
            borderWidth="4px"
            borderColor="transparent"
            transition=".1s linear"
            _hover={{
              borderColor: 'orange.500',
              backgroundColor: 'rgba(0,0,0,0.1)',
            }}
          >
            <pre
              style={{
                padding: 10,
                fontSize: 'medium',
              }}
            >
              {
                'pointSchema: {\n\ttimestamp: Number,\n\tcoords: {\n\t\tlatitude: Number,\n\t\tlongitude: Number,\n\t\taltitude: Number,\n\t\taccuracy: Number,\n\t\theading: Number,\n\t\tspeed: Number\n\t}\n}'
              }
            </pre>
          </Box>
        </Box>
      </WrapItem>
    </Wrap>
  );
};

export default TrackerAppSchema;
